import * as yup from 'yup';

export interface UseCaseGroupFormFields {
  name: string;
}

export const useCaseGroupValidationSchema = yup.object().shape({
  name: yup
    .string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(255, 'Name must not exceed 255 characters'),
});
